import axiosBase from "api/axiosBase";

export const apiLoadProduct = (id) => () => axiosBase.get("house/" + id);
